__turbopack_context__.v({
  "step1": "YotiStepsDescriptionBox-module__Fssg7G__step1",
  "step3": "YotiStepsDescriptionBox-module__Fssg7G__step3",
  "stepIcon": "YotiStepsDescriptionBox-module__Fssg7G__stepIcon",
  "stepItem": "YotiStepsDescriptionBox-module__Fssg7G__stepItem",
  "stepTitle": "YotiStepsDescriptionBox-module__Fssg7G__stepTitle",
  "stepsContainer": "YotiStepsDescriptionBox-module__Fssg7G__stepsContainer",
});
